import React from "react";

const SubHeader = () => {
  return (
    <div className="sub-header">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-md-8">
            <ul className="info">
              <li>
                <a
                  href="/iletisim"
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <i className="fa fa-headset" aria-hidden="true"></i> Yardım ve
                  Destek
                </a>
              </li>
              {/* <li>
            <i className="fa fa-id-card" aria-hidden="true"></i>Yetki
            Numaramız: <strong className="ms-1"> 2600931 - 2601031</strong>
          </li> */}
            </ul>
          </div>
          {/* <div className="col-lg-4 col-md-4">
        <ul className="social-links">
          <li>
            
              href="https://www.linkedin.com/company/kodjet-yazilim/"
              aria-label="LinkedIn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-linkedin" aria-hidden="true"></i>
            </a>
          </li>
        </ul>
      </div> */}
        </div>
      </div>
    </div>
  );
};

export default SubHeader;
